import template from './assignmentsUnassigned.html';
import controller from './assignmentsUnassigned.controller';

let assignmentsUnassignedComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default assignmentsUnassignedComponent;



// WEBPACK FOOTER //
// ./app/components/assignmentsUnassigned/assignmentsUnassigned.component.js